import { Component } from "@angular/core";

@Component({
  selector: "ngx-footer",
  template: `
    <span class="created-by">
      مطور من قبل
      <b><a href="https://sumer.vip" target="_blank">سومر للبرمجيات</a></b>
    </span>
  `,
})
export class FooterComponent {}
